const states = [
    { tab: 1, label: "registration.tabs.contact", name: "PersonalInformation", status: "", isHide: false },
    { tab: 2, label: "registration.tabs.billing", name: "Billing", status: "", errMsg: "", previous: "", isHide: false },
    { tab: 2, label: "registration.tabs.terms", name: "Terms", status: "", isHide: false },
    { tab: 3, label: "registration.tabs.security", name: "Security", status: "", isHide: false },
    { tab: 4, label: "registration.tabs.auth", name: "TwoFactorMFA", status: "", isHide: false },
    // { tab: 5, label: "Notification", name: "NotificationPreference", status: "" },
    { tab: 5, label: "registration.tabs.personalInformation", name: "PersonalInformationEnd", status: "", isHide: false },
];
const FirstTermsStates = [
    { tab: 1, label: "registration.tabs.terms", name: "Terms", status: "", isHide: false },
    { tab: 2, label: "registration.tabs.contact", name: "PersonalInformation", status: "", isHide: false },
    { tab: 3, label: "registration.tabs.personalInformation", name: "PersonalInformationEnd", status: "", isHide: false },
];

const updateState = (states: any, billing: boolean, stateTab: number, errMsg?: string) => {
    let filteredStates;

    filteredStates = states.filter((state: any) => {
        if (!state.isHide) {
            return state.name !== (billing ? "Terms" : "Billing");
        }
        return null;
    });
    return filteredStates.map((state: any, index: number) => {
        if (state.tab < stateTab) {
            state.status = "timeline-past";
            return state;
        } else if (state.tab === stateTab) {
            state.status = "timeline-current";
            if (errMsg) {
                state.errMsg = errMsg;
            }
            return state;
        } else {
            return state;
        }
    });
};

export { updateState, states, FirstTermsStates };
